import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2efyz8hm5: FaireProductEntity = {
  token: "p_u2efyz8hm5",
  type: "product",
  name: "Watermelon & Chili – Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/9ba70418ff63b7123aeffd203f8d3326a78149cdd71020dcac40e2db18e28368.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a9c7f02b625ffed278c9d080eb75f441f88dbffdae5cf73a7e543cd52df0829.jpeg",
    "https://cdn.faire.com/fastly/e1922a59747288af5635d37ed8f8cf8699f7fd733763a303b9052b3a81a2c916.jpeg",
    "https://cdn.faire.com/fastly/99629845fda9a94ad1d296487d52650846d4077a0cc9c453d68a269af820b66c.jpeg",
    "https://cdn.faire.com/fastly/dac936c136439e5dce69e03119836478cc75f67ed6e18fbb647f4cc77b7208c7.jpeg",
    "https://cdn.faire.com/fastly/ad63abf533efb8e446d6e574db7a04e8d7ec6d0b3c4bd68452a72b1d759d1a8a.jpeg",
  ],
  priceDollars: 11,
  description:
    "*LIMITED EDITION* \n\nA joyful, juicy gourmand. Inspired by carefree summers in California. Bitter rind and peppery geranium are brightened by fresh-cut watermelon and lime, with earthy elements of tamarind root, dried chili, and salt. \n\nHere for a limited time only.\n",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:44.501Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
